import dayjs, { Dayjs } from 'dayjs';
import { EMapLayer, TDateListItem, TLayerInfo } from 'types';

/**/
const DAYS_BEFORE = 3; // How many earlier days we want to have in the scale.
const DAYS_TOTAL = 8;

/**/
export type TLayerInfoSimple = Omit<TLayerInfo, 'dateList'> & {
  dateList: string[];
};

/**
 *
 */
function generateDateList() {
  return Array(DAYS_TOTAL)
    .fill(null)
    .map((_, idx) => idx - DAYS_BEFORE)
    .map((num) => dayjs().add(num, 'days'));
}

/**
 *
 */
export function getDateList(dateList: string[]): TDateListItem[] {
  return generateDateList().map((d: Dayjs) => {
    const dt = d.format('YYYY-MM-DDT') + '00:00:00Z';

    return {
      disabled: !dateList.includes(dt),
      label: d.format('MMM DD'),
      dateTime: dt
    };
  });
}

/**
 *
 */
function processDates(info: TLayerInfoSimple): TLayerInfo {
  if (!info) return {} as any;

  return {
    ...info,
    dateList: getDateList(info.dateList)
  };
}

/**
 *
 */
export function handleLayersInfo(
  info: Record<number, TLayerInfoSimple>
): Record<EMapLayer, TLayerInfo> {
  const data = {};
  Object.values(info).forEach((v: TLayerInfoSimple) => v && (data[v.name] = v));

  return {
    [EMapLayer.CHLOROPHYLL]: processDates(data['ChlorophyllSmooth']),
    [EMapLayer.ICE_COVERAGE]: processDates(data['IceCoverageSmooth']),
    [EMapLayer.PHYTOPLANKTON]: processDates(data['PlanktonSmooth']),
    [EMapLayer.SALINITY]: processDates(data['SalinitySmooth']),
    [EMapLayer.SEATEMP]: processDates(data['SeaTemperatureSmooth']),
    [EMapLayer.SURFACETEMP]: processDates(data['SeaTemperatureSmooth']),
    [EMapLayer.UPWELLING]: processDates(data['UpwellingSmooth']),
    [EMapLayer.ZOOPLANKTON]: processDates(data['ZooplanktonSmooth'])
  } as any;
}

/**
 *
 */
export function getSelectedDate(list: TDateListItem[]): string {
  if (!Array.isArray(list) || list.length === 0) return;

  return list.length < DAYS_BEFORE + 1
    ? list[list.length - 1].label
    : list[DAYS_BEFORE].label;
}
